<template>
  <div class="page page-thl" ref="page">
    <clp-dialog :show=this.bool.showDialog tablet="white">
      <makc-alert v-show="this.str.dialogType === 'server_fail'" @closeDialog="this.bool.showDialog = false"/>
      <makc-alert v-show="this.str.dialogType === 'loader'" type="loader" title="Пожалуйста, подождите"/>
      <div v-show="this.str.dialogType === 'payment'" class="payment">
        <div class="payment__title text-b text-lger">Выберите способ оплаты</div>
        <!-- <div class="payment__descr text-mid">Вы&nbsp;можете оплатить любым из&nbsp;указанных способов. Обращаем внимание, без оплаты договор не&nbsp;начнет действовать!</div> -->
        <div class="payment__controls">
          <div class="payment__qr">
            <div class="payment__qr-title">Оплатить по&nbsp;QR-коду</div>
            <img class="payment__qr-img" src="@/create/assets/images/qr.png" alt="qr.png">
          </div>
          <div class="payment__btns">
            <button class="payment__btns-btn button button--makc">Оплатить картой</button>
            <button class="payment__btns-btn button button--makc button--makc-blue">Оплатить СБП</button>
            <button @click="this.bool.showDialog = false"
                    class="payment__btns-btn button button--makc button--makc-unfilled">Назад
            </button>
          </div>
        </div>
      </div>
    </clp-dialog>
    <!-- Превью шире контейнера -->
    <div v-show="isStep('zero')" class="preview-imaged preview-imaged--thl mob-mb20">
      <img class="preview-imaged__image" src="@/create/assets/images/thl-bg.jpg" alt="preview-imaged__image">
      <img class="preview-imaged__image-mobile" src="@/create/assets/images/thl-bg-mobile.jpg"
           alt="preview-imaged__image-mobile">
      <div class="preview-imaged__content">
        <div class="preview-imaged__text">
          <p class="preview-imaged__text-title text-b text-enorm mb10 mob-mb0">Телохранитель</p>
          <p class="preview-imaged__text-subtitle text-sb text-med mb30 mob-mb10">Программа страхования от&nbsp;несчастных&nbsp;случаев</p>
          <p class="preview-imaged__text-subtitle text-r text-med text-mob-dn">
            Программа рассчитана на защиту семьи и близких от рисков причинения вреда жизни и здоровью,
            связанных с непредвиденными жизненными обстоятельствами.
          </p>
        </div>
        <div class="preview-imaged__btns">
          <button @click="changeStep('one')" class="preview-imaged__btns-btn button button--makc">
            Оформить
          </button>
          <button @click="this.$refs.details.scrollIntoView({ behavior: 'smooth'})"
                  class="preview-imaged__btns-btn button button--makc button--makc-unfilled">
            Подробнее
          </button>
        </div>
      </div>
    </div>
    <div class="container container--thl">
      <div class="content content--thl">
        <!-- Превью -->
        <div v-show="isStep('zero')">
          <!-- Преимущества программы -->
          <section class="content__section content__section--advantages section section--makc mob-mb20">
            <h3 class="section__title text-b text-lger text-mob-med">
              Преимущества программы
            </h3>
            <div class="cards cards--four">
              <ul class="cards__list">
                <li class="cards__item">
                  <div class="card card--small">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/images/docs-check.png" alt="">
                    </div>
                    <p class="card__descr text-med text-mob-smer">Широкий спектр<br>покрываемых рисков</p>
                    <span @click="this.$refs.four_tabs.scrollIntoView({ behavior: 'smooth'}); changeFourTabs('spectre')"
                          class="card__link" href="#">Узнать больше →</span>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--small">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/images/umbrella.png" alt="">
                    </div>
                    <p class="card__descr text-med text-mob-smer">Страховая защита<br>24/7</p>
                    <span @click="this.$refs.four_tabs.scrollIntoView({ behavior: 'smooth'}); changeFourTabs('defense')"
                          class="card__link" href="#">Узнать больше →</span>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--small">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/images/world-check.png" alt="">
                    </div>
                    <p class="card__descr text-med text-mob-smer">Защита<br>по всему миру</p>
                    <span @click="this.$refs.four_tabs.scrollIntoView({ behavior: 'smooth'}); changeFourTabs('world')"
                          class="card__link" href="#">Узнать больше →</span>
                  </div>
                </li>
                <li class="cards__item">
                  <div class="card card--small">
                    <div class="card__image">
                      <img class="card__image-icon icon" src="@/create/assets/images/doc-pencil.png" alt="">
                    </div>
                    <p class="card__descr text-med text-mob-smer">Минимальный пакет<br>документов</p>
                    <span @click="this.$refs.four_tabs.scrollIntoView({ behavior: 'smooth'}); changeFourTabs('docs')"
                          class="card__link" href="#">Узнать больше →</span>
                  </div>
                </li>
              </ul>
            </div>
            <div ref="details"></div>
          </section>
          <!-- Табы -->
          <section class="content__section content__section--terms-risks section section--makc">
            <!-- Табы 1 -->
            <div class="clp-tabs">
              <div @click="changeTermsRisksTab('terms')"
                   class="clp-tabs__tab text-b text-med text-mob-mid"
                   :class="{'clp-tabs__tab--selected': isTermsRisksTab('terms')}"
              >Условия программы
              </div>
              <div @click="changeTermsRisksTab('risks')"
                   class="clp-tabs__tab text-b text-med text-mob-mid"
                   :class="{'clp-tabs__tab--selected': isTermsRisksTab('risks')}"
              >Страховые риски
              </div>
            </div>
            <!-- Условия программы -->
            <div class="table-striped mb30" v-if="isTermsRisksTab('terms')">
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Срок страхования</div>
                <div class="table-striped__row-descr">1 год (вступает в силу на 8-ой день, следующий за датой заключения
                  договора)
                </div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Застрахованный</div>
                <div class="table-striped__row-descr">от 1 до 65 лет</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Страхователь</div>
                <div class="table-striped__row-descr">от 18 до 65 лет</div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Страховая премия</div>
                <div class="table-striped__row-descr"> {{ `${this.baseValueFor500000Program} руб.`}} </div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Действие программы</div>
                <div class="table-striped__row-descr">24/7</div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Территория страхования</div>
                <div class="table-striped__row-descr">Весь мир</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Периодичность выплаты дохода</div>
                <div class="table-striped__row-descr">Единовременно (в&nbsp;день заключения договора)</div>
              </div>
            </div>
            <!-- Страховые риски -->
            <div class="table-striped table-striped--halves mb30" v-if="isTermsRisksTab('risks')">
              <div class="table-striped__row">
                <div class="table-striped__row-title">Травма в результате НС (включает любительский спорт*)</div>
                <div class="table-striped__row-descr">До 250 000 р.</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Госпитализация в результате НС</div>
                <div class="table-striped__row-descr">500 000 р.</div>
              </div>
              <div class="table-striped__row">
                <div class="table-striped__row-title">Инвалидность I или II в результате НС</div>
                <div class="table-striped__row-descr">500 000 р.</div>
              </div>
              <div class="table-striped__row table-striped__row--stripe">
                <div class="table-striped__row-title">Уход из жизни в результате НС</div>
                <div class="table-striped__row-descr">500 000 р.</div>
              </div>
              <div class="table-striped__row text-mob-dn"><br></div>
              <div class="table-striped__row text-mob-dn"><br></div>
              <div class="table-striped__row text-mob-dn"><br></div>
            </div>

            <!-- 4 Таба -->
            <div class="clp-tabs clp-tabs--four" ref="four_tabs">
              <div @click="changeFourTabs('spectre')"
                   class="clp-tabs__tab text-b text-med text-mob-smer"
                   :class="{'clp-tabs__tab--selected': isFourTabs('spectre')}"
              >Широкий спектр покрываемых рисков
              </div>
              <div @click="changeFourTabs('defense')"
                   class="clp-tabs__tab text-b text-med text-mob-smer"
                   :class="{'clp-tabs__tab--selected': isFourTabs('defense')}"
              >Страховая защита 24/7
              </div>
              <div @click="changeFourTabs('world')"
                   class="clp-tabs__tab text-b text-med text-mob-smer"
                   :class="{'clp-tabs__tab--selected': isFourTabs('world')}"
              >Защита по всему миру
              </div>
              <div @click="changeFourTabs('docs')"
                   class="clp-tabs__tab text-b text-med text-mob-smer"
                   :class="{'clp-tabs__tab--selected': isFourTabs('docs')}"
              >Минимальный пакет документов
              </div>
            </div>
            <div class="table-striped mb30">
              <div class="table-striped__row">
                <div class="table-striped__row-descr text-mid" v-if="isFourTabs('spectre')">
                  Программа покрывает самые распространенные риски: травмы, полученные в результате несчастного случая,
                  в том числе при занятиях любительскими видами спорта, госпитализацию, инвалидность I и II группы и
                  смерть в результате НС.
                </div>
                <div class="table-striped__row-descr text-mid" v-if="isFourTabs('defense')">
                  Программа действует круглосуточно в течение года (вступает в силу на 8-ой день, следующий за датой
                  заключения договора и оплаты страховой премии)
                </div>
                <div class="table-striped__row-descr text-mid" v-if="isFourTabs('world')">
                  Программа действует как защита от несчастного случая в любой точке мира.<br>&nbsp;
                </div>
                <div class="table-striped__row-descr text-mid" v-if="isFourTabs('docs')">
                  Для оформления страхования вам понадобится паспорт для подтверждения личности и свидетельство о
                  рождении для оформления договора страховой защиты ребенка.
                </div>
              </div>
            </div>
            <!-- Рассчитать -->
            <div class="section__btns">
              <button @click="changeStep('one'); this.$refs.page.scrollIntoView()"
                      class="section__btns-btn button button--makc button--makc-bigger">
                Рассчитать
              </button>
            </div>
          </section>
        </div>
        <!-- Степпер -->
        <div class="stepper"
             :class="{'stepper--on-step-zero': isStep('zero'),'stepper--on-step-one': isStep('one'),'stepper--on-step-two': isStep('two'),'stepper--on-step-three': isStep('three'),}"
        >
          <!-- <div @click="changeStep('one')" class="stepper__step stepper__step--first"> -->
          <div class="stepper__step stepper__step--first">
            <div class="stepper__num ">1</div>
            <div class="stepper__title">Расчет</div>
          </div>

          <!-- <div @click="changeStep('two')" class="stepper__step stepper__step--sec"> -->
          <div class="stepper__step stepper__step--sec">
            <div class="stepper__num">2</div>
            <div class="stepper__title">Оформление</div>
          </div>

          <!-- <div @click="changeStep('zero')" class="stepper__step stepper__step--third"> -->
          <div class="stepper__step stepper__step--third">
            <div class="stepper__num">3</div>
            <div class="stepper__title">Оплата</div>
          </div>
        </div>
        <!-- Расчет -->
        <div v-show="isStep('one')" style="margin-top: 64px;">
          <!-- Выберите программу страхования -->
          <!-- <div class="content__title text-sb text-giant text-mob-lger mb30">Предварительный расчет</div>    -->
          <section class="content__section content__section--choose section section--makc">
            <h3 class="section__title text-sb text-med text-mob-mid">
              Выберите программу&nbsp;страхования
            </h3>
            <div class="largecards largecards--choose">
              <ul class="largecards__list">
                <!-- Пакет «Телохранитель» -->
                <li class="largecards__item">
                  <div @click="changePackage('regular', this.baseValueFor500000Program)"
                       class="largecard largecard--choose largecard--choose-thl"
                       :class="{'largecard--choose-selected': isPackage('regular')}"
                  >
                    <div class="largecard__top">
                      <div class="largecard__title text-b text-lg text-mob-mid">«Телохранитель»</div>
                      <div class="largecard__descr text-mid text-mob-tiny">
                        Страховая защита на&nbsp;случай травм, госпитализаций, получения инвалидности&nbsp;I или&nbsp;II
                        группы или ухода из&nbsp;жизни в&nbsp;результате несчастного случая, в&nbsp;том числе при
                        занятиях любительским спортом
                      </div>
                    </div>
                    <div class="largecard__bottom">
                      <div class="largecard__bottom-heading text-b text-med text-mob-sm">Страховая сумма:</div>
                      <div class="largecard__bottom-price text-b text-ger text-mob-mid">500&nbsp;000 рублей</div>
                    </div>
                  </div>
                </li>
                <!-- Пакет «Телохранитель PRO» -->
                <li class="largecards__item">
                  <div @click="changePackage('extra', this.baseValueFor1000000Program)"
                       class="largecard largecard--choose largecard--choose-thl"
                       :class="{'largecard--choose-selected': isPackage('extra')}"
                  >
                    <div class="largecard__top">
                      <div class="largecard__title text-b text-lg text-mob-mid">«Телохранитель PRO»</div>
                      <div class="largecard__descr text-mid text-mob-tiny">
                        Страховая защита для всех случаев, предусмотренных в&nbsp;программе &laquo;Телохранитель&raquo;,
                        а&nbsp;также на&nbsp;случай хирургических операций в&nbsp;результате несчастного случая и&nbsp;ухода
                        из&nbsp;жизни в&nbsp;результате инфекционных заболеваний
                      </div>
                    </div>
                    <div class="largecard__bottom">
                      <div class="largecard__bottom-heading text-b text-med text-mob-sm">Страховая сумма:</div>
                      <div class="largecard__bottom-price text-b text-ger text-mob-mid">1&nbsp;000&nbsp;000 рублей</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </section>

          <!-- Оформление -->
          <div class="content__title text-sb text-giant text-mob-med mb10" ref="registration">Оформление</div>
          <section class="content__section content__section--registration section section--makc">
            <!-- Страхователь -->
            <div class="wrapper--bordered">
              <h3 class="section__title text-med text-mob-mid mb30 mob-mb20">Страхователь</h3>
              <!-- ФИО - Дата рождения -->
              <div class="inputs inputs--makc mb20">
                <ul class="inputs__list">
                  <!-- Фамилия -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="insurer_surname">Фамилия</label>      -->
                      <input v-model="this.obj.insurer.surname" class="clp-input__control" type="text"
                             id="insurer_surname" placeholder="Фамилия">
                      <label v-if="this.arr.errors[0] === 'insurer_surname' && this.bool.showErrors"
                             class="clp-input__error" for="insurer_surname">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <!-- Имя -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="insurer_name">Имя</label>         -->
                      <input v-model="this.obj.insurer.name" class="clp-input__control" type="text" id="insurer_name"
                             placeholder="Имя">
                      <label v-if="this.arr.errors[0] === 'insurer_name' && this.bool.showErrors"
                             class="clp-input__error" for="insurer_name">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <!-- Отчество (при наличии) -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="insurer_patronymic">Отчество (при наличии)</label>          -->
                      <input v-model="this.obj.insurer.patronymic" :disabled="this.obj.insurer.noPatronymic"
                             class="clp-input__control" type="text" id="insurer_patronymic"
                             placeholder="Отчество (при наличии)">
                      <label v-if="this.arr.errors[0] === 'insurer_patronymic' && this.bool.showErrors"
                             class="clp-input__error" for="insurer_patronymic">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <!-- Отчество отсутствует -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="checkbox checkbox--makc mob-mb0">
                      <input v-model="this.obj.insurer.noPatronymic" @click="this.obj.insurer.patronymic = ''"
                             class="checkbox__input" type="checkbox" name="check_no_patr_inser"
                             value="check_no_patr_inser" id="check_no_patr_inser"
                      >
                      <label class="checkbox__label" for="check_no_patr_inser">
                        <span class="checkbox__label--icon">
                          <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                        </span>
                        <span class="checkbox__label--text">Отчество отсутствует</span>
                      </label>
                    </div>
                  </li>
                  <!-- Дата рождения -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                    <div class="clp-input clp-input--makc">
                      <label class="clp-input__label" for="insurer_birth_date">Дата рождения</label>
                      <input v-model="this.obj.insurer.birth_date" class="clp-input__control" type="date"
                             id="insurer_birth_date">
                      <label v-if="this.arr.errors[0] === 'insurer_birth_date' && this.bool.showErrors"
                             class="clp-input__error" for="insurer_birth_date">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <!-- Телефон -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="insurer_phone">Телефон</label>                                 -->
                      <input v-model="this.obj.insurer.phone" class="clp-input__control" type="text" id="insurer_phone"
                             placeholder="Телефон"
                             v-mask="{
                                                mask: '+7 (FD#) ###-##-##',
                                                tokens: {
                                                    F: {
                                                    pattern: /[3489]/,
                                                    },
                                                    D: {
                                                    pattern: this.obj.insurer.phone[4] == '8' ? /[0-8]/ : /\d/,
                                                    },
                                                    '#': { pattern: /\d/ },
                                                },
                                            }"
                      >
                      <label v-if="this.arr.errors[0] === 'insurer_phone' && this.bool.showErrors"
                             class="clp-input__error" for="insurer_phone">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                  <!-- Электронная почта -->
                  <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                    <div class="clp-input clp-input--makc">
                      <!-- <label class="clp-input__label" for="insurer_email">Электронная почта</label>                                 -->
                      <input v-model="this.obj.insurer.email" class="clp-input__control" type="email" id="insurer_email"
                             placeholder="Электронная почта">
                      <label v-if="this.arr.errors[0] === 'insurer_email' && this.bool.showErrors"
                             class="clp-input__error" for="insurer_email">{{ this.arr.errors[1] }}</label>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- Страхователь является Застрахованным -->
              <div class="section__checkbox checkbox checkbox--makc checkbox--makc-giant">
                <input v-model="this.bool.insurerIsInsured" class="checkbox__input" type="checkbox"
                       name="insurer_insured" value="insurer_insured" id="insurer_insured">
                <label class="checkbox__label" for="insurer_insured">
                  <span class="checkbox__label--icon">
                    <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                  </span>
                  <span class="checkbox__label--text text-mob-sm">Страхователь является Застрахованным</span>
                </label>
              </div>
            </div>
            <!-- Застрахованный -->
            <div v-show="!this.bool.insurerIsInsured" class="wrapper--bordered">
              <h3 class="section__title text-med mb20">Застрахованный</h3>
              <div class="thl-insured--primary">
                <!-- <div class="section__subtitle text-b text-mid text-mob-sm mb30">Основное Застрахованное лицо <br>(возраст от 18 до 65 лет)</div> -->
                <div>
                  <!-- ФИО - Дата рождения -->
                  <div class="inputs inputs--makc mb20">
                    <ul class="inputs__list">
                      <!-- Фамилия -->
                      <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                        <div class="clp-input clp-input--makc">
                          <!-- <label class="clp-input__label" for="primInsured_surname">Фамилия</label>      -->
                          <input v-model="this.obj.primInsured.surname" class="clp-input__control" type="text"
                                 id="primInsured_surname" placeholder="Фамилия">
                          <label v-if="this.arr.errors[0] === 'primInsured_surname' && this.bool.showErrors"
                                 class="clp-input__error" for="primInsured_surname">{{ this.arr.errors[1] }}</label>
                        </div>
                      </li>
                      <!-- Имя -->
                      <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                        <div class="clp-input clp-input--makc">
                          <!-- <label class="clp-input__label" for="primInsured_name">Имя</label>         -->
                          <input v-model="this.obj.primInsured.name" class="clp-input__control" type="text"
                                 id="primInsured_name" placeholder="Имя">
                          <label v-if="this.arr.errors[0] === 'primInsured_name' && this.bool.showErrors"
                                 class="clp-input__error" for="primInsured_name">{{ this.arr.errors[1] }}</label>
                        </div>
                      </li>
                      <!-- Отчество -->
                      <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                        <div class="clp-input clp-input--makc">
                          <!-- <label class="clp-input__label" for="primInsured_patronymic">Отчество (при наличии)</label>          -->
                          <input v-model="this.obj.primInsured.patronymic" :disabled="this.obj.primInsured.noPatronymic"
                                 class="clp-input__control" type="text" id="primInsured_patronymic"
                                 placeholder="Отчество (при наличии)">
                          <label v-if="this.arr.errors[0] === 'primInsured_patronymic' && this.bool.showErrors"
                                 class="clp-input__error" for="primInsured_patronymic">{{ this.arr.errors[1] }}</label>
                        </div>
                      </li>
                      <!-- Отчество отсутствует -->
                      <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-full">
                        <div class="checkbox checkbox--makc mob-mb0">
                          <input v-model="this.obj.primInsured.noPatronymic"
                                 @click="this.obj.primInsured.patronymic = ''"
                                 class="checkbox__input" type="checkbox" name="check_no_patr_insed"
                                 value="check_no_patr_insed" id="check_no_patr_insed">
                          <label class="checkbox__label" for="check_no_patr_insed">
                            <span class="checkbox__label--icon">
                              <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                            </span>
                            <span class="checkbox__label--text">Отчество отсутствует</span>
                          </label>
                        </div>
                      </li>
                      <!-- Дата рождения -->
                      <li class="inputs__item  inputs__item--1-of-4 inputs__item--tablet-1-of-2">
                        <div class="clp-input clp-input--makc">
                          <label class="clp-input__label" for="primInsured_birth_date">Дата рождения</label>
                          <input v-model="this.obj.primInsured.birth_date" class="clp-input__control" type="date"
                                 id="primInsured_birth_date">
                          <label v-if="this.arr.errors[0] === 'primInsured_birth_date' && this.bool.showErrors"
                                 class="clp-input__error" for="primInsured_birth_date">{{ this.arr.errors[1] }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Чекбоксы -->
            <div class="section__checkboxes checkboxes mb30 mob-mb20">
              <ul class="checkboxes__list">
                <ul class="checkboxes__list">
                  <!-- Согласен с Политикой обработки персональных данных -->
                  <li class="checkboxes__item">
                    <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': this.bool.showErrors && !this.arr.markedCheckboxes.includes('personal_data')}">
                      <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                             value="personal_data" id="checkbox1">
                      <label class="checkbox__label" for="checkbox1">
                        <span class="checkbox__label--icon">
                          <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                        </span>
                        <span class="checkbox__label--text">
                                                Согласен с 
                                                <a class="clp-link clp-link--makc" target="_blank"
                                                   href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">
                                                    Политикой обработки персональных данных
                                                </a>
                                            </span>
                      </label>
                    </div>
                  </li>
                  <!-- Ознакомился с Ключевым информационным документом -->
                  <li class="checkboxes__item">
                    <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': this.bool.showErrors && !this.arr.markedCheckboxes.includes('kid')}">
                      <input v-model="this.arr.markedCheckboxes" class="checkbox__input" type="checkbox" name="check[]"
                             value="kid" id="checkbox2">
                      <label class="checkbox__label" for="checkbox2">
                        <span class="checkbox__label--icon">
                          <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                        </span>
                        <span
                            v-show="this.bool.newPolicyAndKidArrived && this.str.kidLink !== '#' && this.arr.errors.length === 0"
                            class="checkbox__label--text">
                                                Ознакомился с  
                                                <a class="clp-link clp-link--makc" target="_blank"
                                                   :href="this.str.kidLink">Ключевым информационным документом</a>
                                            </span>
                        <span
                            v-show="!this.bool.newPolicyAndKidArrived || this.str.kidLink === '#' || this.arr.errors.length > 0"
                            class="checkbox__label--text">
                                                Ознакомился с  
                                                <a class="clp-link clp-link--makc clp-link--makc-fresh-disabled"
                                                   disabled>Ключевым информационным документом</a>
                                            </span>
                      </label>
                    </div>
                  </li>
                  <!-- Ознакомился и согласился с Условиями полиса и Правилами страхования -->
                  <li class="checkboxes__item">
                    <div class="checkbox checkbox--makc checkbox--makc-giant" :class="{'required': this.bool.showErrors && !this.arr.markedCheckboxes.includes('policy_terms_ins_rules')}">
                      <input v-model="this.arr.markedCheckboxes"
                             class="checkbox__input" type="checkbox" name="check[]" value="policy_terms_ins_rules"
                             id="checkbox3"
                            >
                      <label class="checkbox__label" for="checkbox3">
                        <span class="checkbox__label--icon">
                          <img class="icon" src="@/create/assets/icons/check.svg" alt="">
                        </span>
                        <span class="checkbox__label--text">Ознакомился и согласился с
                          <a v-show="this.unlockPolicyTerms()" class="clp-link clp-link--makc"
                             target="_blank" :href="this.str.policyLink">Условиями полиса</a>
                          <a v-show="!this.unlockPolicyTerms()"
                             class="clp-link clp-link--makc clp-link--makc-fresh-disabled"
                             disabled>Условиями полиса</a> и
                          <a class="clp-link clp-link--makc"
                             target="_blank"
                             href="https://makclife.ru/b2b/life/rules/rulesForNS90.8.pdf">Правилами страхования</a>
                          <!-- <a class="clp-link clp-link--makc" target="_blank" :href="this.str.rulesLink">Правилами страхования</a> -->
                        </span>
                      </label>
                    </div>
                  </li>
                </ul>
              </ul>
            </div>
            
            <!-- Соцкарта -->
            <SocialCards :socialCardInfo="obj.socialCardInfo" @checker="obj.socialCardInfo.socialCardType = ''" />
            <div class="mb20"></div>

            <!-- Страховая премия -->
            <div class="section__indicator mb20">
              <div v-show="this.bool.contractAmountExceeded" class="section__indicator-alert text-mid text-mob-smer">
                Страховая премия по&nbsp;договору страхования не&nbsp;может превышать 40&nbsp;000&nbsp;рублей.
                Пожалуйста, разделите список застрахованных лиц на&nbsp;несколько договоров,
                страховая премия по&nbsp;каждому из&nbsp;которых не&nbsp;будет превышать 40&nbsp;000&nbsp;рублей.
              </div>
              <div class="section__indicator-title text-b text-center text-med text-mob-mid">
                Страховая премия
              </div>
              <div class="section__indicator-text" :class="{ 'text-sb': !this.str.contractAmount }">
                {{ this.str.contractAmount ? this.str.contractAmount : '0 ₽' }}
              </div>
            </div>

            <!-- Назад - Продолжить -->
            <div class="section__buttons section__buttons--create-contract">
              <a class="section__buttons-link text-mob-w100" :href="this.goBackLink">
                <button
                    class="section__buttons-button section__button button button--makc button--makc-smaller button--makc-blue">
                  Назад
                </button>
              </a>
              <button @click="createContract" :disabled="!this.unlockToPaymentBtn()"
                      class="section__button button button--makc button--makc-smaller">
                Оплатить
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {ref} from 'vue';
import axios from 'axios';
import ClpDialog from '@/create/components/ClpDialog.vue';
import SocialCards from '@/create/components/SocialCards.vue';
import MakcAlert from '@/create/components/MakcAlert.vue';
import {localDevelopment, testDevelopment, baseURL, requestVersion, subdomain} from "@/create/composables/const";

export default {
  components: {ClpDialog, SocialCards, MakcAlert},
  data() {
    return {
      socialCardHasNoSale: false, // переменная для случаев, когда ввели карту, но по ней не проходит скидка
      baseValueFor1000000Program: '9900.00',
      baseValueFor500000Program: '4900.00',
      contractAmountWithoutSale: '',
      bool: {
        showDialog: false,
        // showDialog: true,
        insurerIsInsured: true,
        // insurerIsInsured: false,
        fieldsAreValidated: false,
        newPolicyAndKidArrived: true,
        // newRulesArrived: true,
        contractArrived: false,
        calcProcess: false,
        formIsChanged: false,
        showErrors: false,
      },
      str: {
        sessionToken: '',
        dialogType: 'server_fail',
        // dialogType: 'loader',
        // dialogType: 'payment',
        currentStep: 'one',
        termsRisksTab: 'terms',
        fourTabs: 'spectre',
        selectedPackage: '',
        kidLink: '#',
        policyLink: '#',
        // rulesLink: '#',
        contractAmount: '',
        social_card: '',
        // contractId: '',
      },
      arr: {
        errors: [],
        markedCheckboxes: [],
      },
      obj: {
        insurer: {
          name: '',
          surname: '',
          patronymic: '',
          noPatronymic: false,
          birth_date: '',
          doc_type: '',
          doc_serial: '',
          doc_number: '',
          doc_date: '',
          doc_issuer: '',
          doc_issuer_code: '',
          phone: '',
          email: '',
          email_repeat: '',
        },
        primInsured: {
          name: '',
          surname: '',
          patronymic: '',
          noPatronymic: false,
          birth_date: '',
          doc_type: '',
          doc_serial: '',
          doc_number: '',
          doc_date: '',
          doc_issuer: '',
          doc_issuer_code: '',
          phone: '',
        },
        callform: {
          name: '',
          phone: '',
          city: '',
        },
        socialCardInfo: {},
      },
    };
  },
  methods: {
    async calcAmount() { // строгая завязка запроса на возраст
      if (this.str.social_card.length > 4 || !this.str.social_card.length) {
        try {
          this.socialCardHasNoSale = false

          const request = {
            sessionToken: this.str.sessionToken,
            format: "json",
            ver: requestVersion,
            object: "contract",
            login: "bodyguard",
            action: "calc",
            agreement: {
              program_type: 'cred',
              program: this.str.selectedPackage === 'regular' ? 'pr_sport' : 'pr_sport_pro',
              ins_calc_amount: this.str.selectedPackage === 'regular' ? '500000' : '1000000',
              ins_calc_type: '1',
              ins_period: '1Y',
              payment_order: '0',
              currency: 'rur',
              // status: 10,
              // bank_policy_premium: 0,
              menu_id: '17',
              insurer_birth_date: this.reworkDate(this.obj.insurer.birth_date),
              insured_birth_date: this.bool.insurerIsInsured ? this.reworkDate(this.obj.insurer.birth_date) : this.reworkDate(this.obj.primInsured.birth_date),
              discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
              discount_card_type: this.obj.socialCardInfo.socialCardType || '',
              discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
              discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
            }
          };

          const response = await axios.post(baseURL, request);
          const r_data = response.data;

          if (this.contractAmountWithoutSale === '' || Number(r_data.ins_fee) > Number(this.contractAmountWithoutSale)) {
            this.contractAmountWithoutSale = r_data.ins_fee;
          }

          if (r_data.ins_fee && this.spaceNumsAddRouble(r_data.ins_fee) !== this.str.contractAmount) {
            this.str.contractAmount = this.spaceNumsAddRouble(r_data.ins_fee);
            this.obj.socialCardInfo.discount = r_data.discount  // отображения текста о том, что скидка сработала
            await this.getKidAndPolicy();
          } else {
            this.bool.showErrors = true;
          }
        } catch (e) {
          console.log('Frontend Error - ' + e)
        }
      }
    },
    async getKidAndPolicy() {
      if (this.fieldsAreValidatedComputed && this.str.selectedPackage) {
        try {
          const request = {
            sessionToken: this.str.sessionToken,
            action: "get_kid",
            format: "json",
            ver: requestVersion,
            object: "contract",
            login: "bodyguard",
            agreement: {
              program_type: 'cred',
              program: this.str.selectedPackage === 'regular' ? 'pr_sport' : 'pr_sport_pro',
              ins_calc_amount: this.str.selectedPackage === 'regular' ? '500000' : '1000000',
              ins_calc_type: '1',
              ins_period: "1Y",
              payment_order: '0',
              currency: "rur",
              insurer: 0,
              insured: this.bool.insurerIsInsured ? '0' : '1',
              status: 10,
              bank_policy_premium: 0,
              menu_id: '17',
              insurer_birth_date: this.reworkDate(this.obj.insurer.birth_date),
              insured_birth_date: this.bool.insurerIsInsured ? this.reworkDate(this.obj.insurer.birth_date) : this.reworkDate(this.obj.primInsured.birth_date),
              insurer_sex: '0',
              insured_sex: '0',
              discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
              discount_card_type: this.obj.socialCardInfo.socialCardType || '',
              discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
              discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
            },
            contacts: [
              {
                first_name: this.obj.insurer.name,
                middle_name: this.obj.insurer.patronymic,
                last_name: this.obj.insurer.surname,
                birth_date: this.obj.insurer.birth_date,
                phone: this.obj.insurer.phone,
                email: this.obj.insurer.email,
                birth_place: '',
                citizenship: 'rf',
                sex: '0',
              },
              {
                first_name: this.obj.primInsured.name,
                middle_name: this.obj.primInsured.patronymic,
                last_name: this.obj.primInsured.surname,
                birth_date: this.obj.primInsured.birth_date,
                phone: '',
                email: '',
                birth_place: '',
                citizenship: 'rf',
                sex: '0',
              }],
          };
          
          this.reworkData(request);
          const response = await axios.post(baseURL, request);
          const r_data = response.data;

          if (r_data.state === 'success') {
            const domain = localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru` : "https://makclife.ru";
            const urlKid = r_data.kid;
            const urlPolicy = r_data.project;

            this.str.kidLink = domain + urlKid;
            this.str.policyLink = domain + urlPolicy;
          } else {
            this.arr.markedCheckboxes = [];
            console.log('backend error after getKidAndPolicy request');
          }
        } catch (e) {
          console.log('Frontend Error - ' + e);
        } finally {
          this.bool.newPolicyAndKidArrived = true
        }
      }
    },
    async createContract() {
      try {
        if (this.arr.errors.length > 0) {
          this.bool.showErrors = true;
          this.$refs.registration.scrollIntoView({behavior: 'smooth'});
          return
        }
        if (this.arr.markedCheckboxes.length !== 3) {
          return this.bool.showErrors = true;
        }

        this.openDialog('loader');
        this.bool.contractArrived = false;

        const request = {
          sessionToken: this.str.sessionToken,
          action: "create",
          format: "json",
          ver: requestVersion,
          object: "contract",
          login: "bodyguard",
          agreement: {
            program_type: 'cred',
            program: this.str.selectedPackage === 'regular' ? 'pr_sport' : 'pr_sport_pro',
            ins_calc_amount: this.str.selectedPackage === 'regular' ? '500000' : '1000000',
            ins_calc_type: '1',
            ins_period: '1Y',
            payment_order: '0',
            currency: "rur",
            insurer: 0,
            insured: this.bool.insurerIsInsured ? '0' : '1',
            status: 10,
            bank_policy_premium: 0,
            menu_id: '17',
            save_kid: 'Y',
            discount: this.obj.socialCardInfo.cardInputNumber ? 'Y' : 'N',
            discount_card_type: this.obj.socialCardInfo.socialCardType || '',
            discount_card_series : this.obj.socialCardInfo.cardInputSerial || '',
            discount_card_number: this.obj.socialCardInfo.cardInputNumber || '',
          },
          contacts: [{
            first_name: this.obj.insurer.name,
            middle_name: this.obj.insurer.patronymic,
            last_name: this.obj.insurer.surname,
            birth_date: this.obj.insurer.birth_date,
            phone: this.obj.insurer.phone,
            email: this.obj.insurer.email,
            birth_place: '',
            citizenship: 'rf',
            sex: '0',
          },
            {
              first_name: this.obj.primInsured.name,
              middle_name: this.obj.primInsured.patronymic,
              last_name: this.obj.primInsured.surname,
              birth_date: this.obj.primInsured.birth_date,
              phone: '',
              email: '',
              birth_place: '',
              citizenship: 'rf',
              sex: '0',
            },],
        };
        
        this.reworkData(request);
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success') {
          this.str.contractId = r_data.id;
          this.getPayLink();
        } else {
          this.openDialog();
          console.log('backend error after createContract request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
      } finally {
        this.bool.requestArrived = true;
      }
    },
    async getPayLink() {
      try {
        const request = {
          format: "json",
          ver: requestVersion,
          action: "creatpay",
          login: "bodyguard",
          policy_id: this.str.contractId,
          phone: this.obj.insurer.phone,
          email: this.obj.insurer.email,
        }
        const response = await axios.post(baseURL, request);
        const r_data = response.data;

        if (r_data.state === 'success' && r_data.url) {
          const paylink = r_data.url.link;
          window.open(paylink, '_self')
        } else {
          this.openDialog();
          // this.errorLogger(r_data);

          console.log('backend error after getPayLink request');
        }
      } catch (e) {
        console.log('Frontend Error - ' + e);
        this.closeDialog();
      }
    },
    async errorLogger(errorData) {
      try {
        console.log('error log sending');
        const request = {
          sessionToken: this.str.sessionToken,
          action: "logger",
          login: "bodyguard",
          data: errorData
        }
        const response = await axios.post(baseURL, request);
        // console.log('error log response.data');
        // console.log(response.data);
      } catch (e) {
      } finally {
      }
    },
    // работа с данными
    getTodaysDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getAge(dateString) {
      let today = new Date();
      let birthDate = new Date(dateString);

      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    addDays(dateString, days) {
      var date = new Date(dateString);
      date.setDate(date.getDate() + days);
      return date;
    },
    spaceNumsAddRouble(nums) {
      return nums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ₽';
    },
    reworkData(obj) {
      const reworkPhone = (phoneNumber) => {
        let phone = phoneNumber.length === 0 ? '+7(985)555-55-55' : phoneNumber;

        const nums = /([0-9]|[+])/g;
        return phone.match(nums).join('')
      }

      for (let item of obj.contacts) {
        item.birth_date = this.reworkDate(item.birth_date);
        item.phone = reworkPhone(item.phone);
      }
    },
    reworkDate(dateNumber) {
      let date = dateNumber.length === 0 ? '2022-02-24' : dateNumber;

      return date.split("-").reverse().join(".")
    },
    // валидация
    frontValidate() {
      this.arr.errors = [];
      // if (this.str.selectedPackage === 'none') {
      //   return false
      // }
      const cyrillicAndNums = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/;
      const cyrillic = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
      const latin = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
      const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;
      // Страхователь
      // ФИО - Дата рождения
      if (!this.obj.insurer.surname) {
        this.arr.errors.push('insurer_surname');
        this.arr.errors.push('укажите фамилию');
        return false
      } else if (!cyrillic.test(this.obj.insurer.surname)) {
        this.arr.errors.push('insurer_surname');
        this.arr.errors.push('допустимы только символы кириллицы');
        return false
      }
      // Имя
      else if (!this.obj.insurer.name) {
        this.arr.errors.push('insurer_name');
        this.arr.errors.push('укажите имя');
        return false
      } else if (!cyrillic.test(this.obj.insurer.name)) {
        this.arr.errors.push('insurer_name');
        this.arr.errors.push('допустимы только символы кириллицы');
        return false
      } else if (this.obj.insurer.name && this.obj.insurer.name === this.obj.insurer.surname) {
        this.arr.errors.push('insurer_name');
        this.arr.errors.push('одинаковые имя и фамилия недопустимы');
        return false
      }
      // Отчество
      else if (!this.obj.insurer.patronymic && !this.obj.insurer.noPatronymic) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('укажите отчество');
        return false
      } else if (this.obj.insurer.patronymic && this.obj.insurer.patronymic === this.obj.insurer.surname) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
        return false
      } else if (this.obj.insurer.patronymic && this.obj.insurer.patronymic === this.obj.insurer.name) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('одинаковые имя и отчество недопустимы');
        return false
      } else if (this.obj.insurer.patronymic && !cyrillic.test(this.obj.insurer.patronymic)) {
        this.arr.errors.push('insurer_patronymic');
        this.arr.errors.push('допустимы только символы кириллицы');
        return false
      }
      // Дата рождения
      else if (!this.obj.insurer.birth_date) {
        this.arr.errors.push('insurer_birth_date');
        this.arr.errors.push('укажите корректную дату рождения');
        return false
      } else if (this.getAge(this.obj.insurer.birth_date) < 18) {
        this.arr.errors.push('insurer_birth_date');
        this.arr.errors.push('минимальный возраст - от 18 лет');
        return false
      } else if (this.getAge(this.addDays(this.obj.insurer.birth_date, -7)) >= 65) {
        this.arr.errors.push('insurer_birth_date');
        this.arr.errors.push('возраст превысит 66 лет к концу действия договора (через 1 г. 8 дн.)');

        return false
      }
      if (!this.obj.insurer.phone) {
        this.arr.errors.push('insurer_phone');
        this.arr.errors.push('укажите номер телефона');
        return false
      } else if (this.obj.insurer.phone.length < 18) {
        this.arr.errors.push('insurer_phone');
        this.arr.errors.push('укажите номер телефона полностью');
        return false
      }
      // Электронная почта
      else if (!this.obj.insurer.email) {
        this.arr.errors.push('insurer_email');
        this.arr.errors.push('укажите адрес электронной почты');
        return false
      } else if (!email.test(this.obj.insurer.email)) {
        this.arr.errors.push('insurer_email');
        this.arr.errors.push('укажите корректный адрес электронной почты');
        return false
      }
      // Застрахованный
      if (!this.bool.insurerIsInsured) {
        // ФИО - Дата рождения
        if (!this.obj.primInsured.surname) {
          this.arr.errors.push('primInsured_surname');
          this.arr.errors.push('укажите фамилию');
          return false
        } else if (!cyrillic.test(this.obj.primInsured.surname)) {
          this.arr.errors.push('primInsured_surname');
          this.arr.errors.push('допустимы только символы кириллицы');
          return false
        }
        // Имя
        else if (!this.obj.primInsured.name) {
          this.arr.errors.push('primInsured_name');
          this.arr.errors.push('укажите имя');
          return false
        } else if (!cyrillic.test(this.obj.primInsured.name)) {
          this.arr.errors.push('primInsured_name');
          this.arr.errors.push('допустимы только символы кириллицы');
          return false
        } else if (this.obj.primInsured.name && this.obj.primInsured.name === this.obj.primInsured.surname) {
          this.arr.errors.push('primInsured_name');
          this.arr.errors.push('одинаковые имя и фамилия недопустимы');
          return false
        }
        // Отчество
        else if (!this.obj.primInsured.patronymic && !this.obj.primInsured.noPatronymic) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('укажите отчество');
          return false
        } else if (this.obj.primInsured.patronymic && this.obj.primInsured.patronymic === this.obj.primInsured.surname) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('одинаковые отчество и фамилия недопустимы');
          return false
        } else if (this.obj.primInsured.patronymic && this.obj.primInsured.patronymic === this.obj.primInsured.name) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('одинаковые имя и отчество недопустимы');
          return false
        } else if (this.obj.primInsured.patronymic && !cyrillic.test(this.obj.primInsured.patronymic)) {
          this.arr.errors.push('primInsured_patronymic');
          this.arr.errors.push('допустимы только символы кириллицы');
          return false
        }
        // Дата рождения
        else if (!this.obj.primInsured.birth_date) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('укажите корректную дату рождения');
          return false
        } else if (this.getAge(this.obj.primInsured.birth_date) < 1) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('минимальный возраст - от 1 года');
          return false
        } else if (this.getAge(this.addDays(this.obj.primInsured.birth_date, -7)) >= 65) {
          this.arr.errors.push('primInsured_birth_date');
          this.arr.errors.push('возраст превысит 66 лет к концу действия договора (через 1 г. 8 дн.)');
          return false
        }
      }
      // Соцкарта
      if (this.str.social_card) {
        if (!cyrillicAndNums.test(this.str.social_card)) {
          this.arr.errors.push('social_card');
          this.arr.errors.push('допустимы только символы кириллицы и цифры');
          return false
        }
      }
      return true
    },
    // действия и ошибки
    changeStep(item) {
      this.str.currentStep = item;
    },

    isStep(item) {
      return this.str.currentStep === item
    },

    changeTermsRisksTab(item) {
      this.str.termsRisksTab = item;
    },

    isTermsRisksTab(item) {
      return this.str.termsRisksTab === item
    },

    changeFourTabs(item) {
      this.str.fourTabs = item;
    },

    isFourTabs(item) {
      return this.str.fourTabs === item
    },

    changePackage(item, price) {
      this.str.selectedPackage = item;
      this.contractAmountWithoutSale = '';
      this.str.contractAmount = this.spaceNumsAddRouble(price);
      if (this.obj.socialCardInfo.cardInputNumber > 4) { // карта есть -> выполняем пересчёт/проверку и смену ссылки
        this.calcAmount();
      } else { // карты нет - просто меняем ссылку и дефолтное значение 4900/9900
        this.getKidAndPolicy();
      }
    },

    isPackage(item) {
      return this.str.selectedPackage === item
    },

    openDialog(type = 'server_fail') {
      this.str.dialogType = type;
      this.bool.showDialog = true;
    },

    closeDialog() {
      this.bool.showDialog = false;
    },

    unlockPolicyTerms() {
      return this.bool.newPolicyAndKidArrived && this.str.policyLink !== '#' && this.arr.errors.length === 0
    },

    unlockToPaymentBtn() {
      return this.str.selectedPackage !== ''
    },
  },
  watch: {
    fieldsAreValidatedComputed(newVal) {
      if (newVal === true) {
        this.getKidAndPolicy();
      }
    },
    'obj.socialCardInfo': {
      async handler() {
        if (this.bool.calcProcess) return this.bool.formIsChanged = true
        else {
          this.bool.calcProcess = true         // включаем, чтобы 1 такой запрос в момент времени
          await this.calcAmount();
          this.bool.calcProcess = false        // и выключаем, чтобы 1 такой запрос в момент времени
          if (this.bool.formIsChanged) {       // и еще проверяем была ли изменена форма за это время
            setTimeout(async() => {
              await this.calcAmount();
              this.bool.formIsChanged = false
            }, 400);
          }
        }
      },
      deep: true
    },
  },
  computed: {
    fieldsAreValidatedComputed() {
      return this.bool.fieldsAreValidated = this.frontValidate();
    },
    goBackLink() {
      if (localDevelopment) {
        return this.str.selectedPackage === 'extra' ? 'https://test12.makclife.ru/riskovoe-strakhovanie/telokhranitel-pro.php' : 'https://test12.makclife.ru/riskovoe-strakhovanie/telokhranitel.php'
      } else {
        return this.str.selectedPackage === 'extra' ? 'https://makclife.ru/riskovoe-strakhovanie/telokhranitel-pro.php' : 'https://makclife.ru/riskovoe-strakhovanie/telokhranitel.php'
      }
    },
  },
  mounted() {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    if (urlParams.has('from') && urlParams.get('from') === 'reg') {
      this.str.selectedPackage = 'regular';
    } else if (urlParams.has('from') && urlParams.get('from') === 'pro') {
      this.str.selectedPackage = 'extra';
    }

    this.closeDialog();
    window.document.head.getElementsByTagName('title')[0].innerHTML = 'Телохранитель'
    this.str.sessionToken = new Date;
  },
}
</script>


<style scoped lang="scss">
.required {
    span {
        color: #ff144f;
        border-color: #ff144f;
    }
}

</style>